<template lang="html">
  <div>
    <div class="m_tabbar">
      <ul>
        <li :class="{on: '/home' === $route.path}" @click="goTo('/home')">
          <i>&#xe604;</i>
          <span>首页</span>
        </li>
        <li :class="{on: '/community' === $route.path}" @click= "goTo('/community')">
          <i>&#xe6bd;</i>
          <span>社区</span>
        </li>
        <li :class="{on: '/integral' === $route.path}" @click= "goTo('/integral')">
          <i>&#xe629;</i>
          <span>积分</span>
        </li>
        <li :class="{on: '/user' === $route.path}" @click= "goTo('/user')">
          <i>&#xe622;</i>
          <span>我的</span>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'

export default {
  methods:{
    goTo(path) {
      this.$router.replace(path)
    }
  }

}
</script>

<style lang="scss" scoped>
  .m_tabbar{
    width: 100%;
    height: .5rem;
    position: fixed;
    left: 0;
    bottom: 0;
    background: #FFF;
    border-top: 1px solid #EEE;
    ul{
      width: 100%;
      height: 100%;
      display: flex;
      li{
        flex: 1;
        display: flex;
        flex-direction: column;
        i{
          height: .3rem;
          line-height: .3rem;
          text-align: center;
          font-size: .18rem;
        }
        span{
          height: .2rem;
          text-align: center;
        }
      }
      li.on{
        color: red !important;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterBar/FooterBar.vue